import { PRODUCT_CATEGORY } from '@schuettflix/interfaces';
import { useTranslation } from 'react-i18next';
import { Tag } from '@schuettflix/planum-react';
import { useFormatters } from '@/shared/hooks/useFormatters/useFormatters.ts';
import { ORGANIZATION_ROLE_LABEL } from '@/shared/components/FinanceSettings/OrganizationRoleLabels.ts';

const productCategoryToOrganizationRoleMap = {
    MATERIAL: 'SUPPLIER',
    TRANSPORT: 'CARRIER',
    MATERIAL_SERVICE: 'CUSTOM',
    TRANSPORT_SERVICE: 'CUSTOM',
} as const satisfies Record<PRODUCT_CATEGORY, string>;

type FinanceSettingsOrgHeaderProps = {
    label: string;
    totalAmountNet: number;
    includedProductCategories: PRODUCT_CATEGORY[];
    showRoles?: boolean;
};

export function FinanceSettingsHeader({
    label,
    totalAmountNet,
    includedProductCategories,
    showRoles = true,
}: FinanceSettingsOrgHeaderProps) {
    const { t } = useTranslation();
    const { formatNumberWithCurrency } = useFormatters();

    const roles = [...new Set(includedProductCategories.map(c => productCategoryToOrganizationRoleMap[c]))];

    return (
        <div className="flex items-center gap-6">
            <div className="flex-1 overflow-hidden">
                {showRoles && (
                    <p className="font-copy-sm">{roles.map(role => t(ORGANIZATION_ROLE_LABEL[role])).join(', ')}</p>
                )}
                <h3 className="font-copy-md-strong truncate">{label}</h3>
            </div>
            <div className="flex-none">
                <Tag
                    prominence="base"
                    purpose={totalAmountNet < 0 ? 'critical' : 'success'}
                    size="md"
                    className="whitespace-nowrap font-bold"
                >
                    {formatNumberWithCurrency(Math.abs(totalAmountNet))}
                </Tag>
            </div>
        </div>
    );
}
